import { Dialog } from './dialog';
import { useFullscreenDialogParent } from '../../general/use-fullscreen-dialog-parent';

type UserPromptDialogProps = {
  visible: boolean;
  title?: string;
  question: string; // may contain HTML
  actions: React.ReactNode[]; // array of <Button> elements
  onClose: () => void;
  children?: React.ReactNode;
  parent?: HTMLElement | null;
};

export function UserPromptDialog({
  visible,
  title = "Please confirm",
  question,
  actions,
  onClose,
  children,
  parent
}: UserPromptDialogProps) {
  const dialogParent = useFullscreenDialogParent(parent);
  return (
    <Dialog
      header={
        <div className="flex align-items-center gap-2">
          <i className="pi pi-question-circle text-blue-500 text-xl" />
          <span className="font-semibold text-lg">{title}</span>
        </div>
      }
      visible={visible}
      onHide={onClose}
      modal
      appendTo={dialogParent}
      style={{ width: "600px", maxWidth: "95vw" }}
    >
      <div className="flex flex-column gap-3">
        <div
          className="text-900"
          style={{
            lineHeight: 1.5,
            whiteSpace: "normal"
          }}
          dangerouslySetInnerHTML={{ __html: question }}
        />
        {children}

        <div className="flex justify-content-end gap-2">
          {actions.map((btn, idx) => (
            <span key={idx}>{btn}</span>
          ))}
        </div>
      </div>
    </Dialog>
  );
}
